// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2Dl8Q","noInteraction":"EventWrapper_noInteraction__4cpWF","pointerPassthrough":"EventWrapper_pointerPassthrough__1ouY0"};